import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { setFullScreenDialogOpen } from "store/actions/utilActions";
//#endregion
//#region types
import { DialogProps } from "models/propTypes/dialogPropTypes";
//#endregion
//#region components
import FullScreenView from "./_fullscreenView";
//#endregion

const FullScreenNoSpeedDialDialog: React.FC<DialogProps> = (props) => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(setFullScreenDialogOpen(true, "wizard"));

    return () => {
      dispatch(setFullScreenDialogOpen(false));
    };
  }, []);

  return <FullScreenView {...props} />;
};

export default FullScreenNoSpeedDialDialog;
